import { apiClient } from '../../../shared/api/apiClient';

const CAMPAIGNS_PATH = '/message-templates/campaigns/';
const TAGS_PATH = '/message-templates/tags/';
const TRIGGERS_PATH = '/message-templates/triggers/';
const VARIABLES_PATH = '/message-templates/variables/';
const DISCLOSURES_PATH = '/message-templates/disclosures/';
const TENANTS_PATH = '/users/tenants/';

function withQuery(path, params) {
  const qs = params?.toString?.() ?? '';
  return qs ? `${path}?${qs}` : path;
}

export function fetchCampaigns() {
  return apiClient.get(CAMPAIGNS_PATH);
}

export function fetchTags({ search } = {}) {
  const params = new URLSearchParams();
  const trimmed = search != null ? String(search).trim() : '';
  if (trimmed) params.set('search', trimmed);
  return apiClient.get(withQuery(TAGS_PATH, params));
}

export function fetchTriggers({ channel } = {}) {
  const params = new URLSearchParams();
  if (channel) params.set('channel', channel);
  return apiClient.get(withQuery(TRIGGERS_PATH, params));
}

export function fetchVariables({ channel, search }) {
  const params = new URLSearchParams({ channel });
  if (search) params.set('search', search);
  return apiClient.get(withQuery(VARIABLES_PATH, params));
}

export function fetchDisclosures() {
  return apiClient.get(DISCLOSURES_PATH);
}

export function fetchTenants() {
  return apiClient.get(TENANTS_PATH);
}
